<template>
  <v-list>
    <v-list-group sub-group>
      <template v-slot:activator class="pa-0">
        <v-list-item-title class="pa-0">{{ title }}</v-list-item-title>
      </template>
      <v-list-item class="pa-0">
        <slot></slot>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
export default {
  name: "Sublist",
  props: {
    title: String
  }
};
</script>
<style lang="scss">
//
.v-list {
  padding: 0 !important;
}
//
.v-list-item__title {
  color: white !important;
}

//
.v-list-group__items > div > div {
  div.v-list-item {
    padding-left: 0.5rem !important;
    padding-right: 1rem;
  }
}
</style>
